import { render } from "./ClientAccordionSection.vue?vue&type=template&id=29db8afe&scoped=true"
import script from "./ClientAccordionSection.vue?vue&type=script&lang=js"
export * from "./ClientAccordionSection.vue?vue&type=script&lang=js"

import "./ClientAccordionSection.vue?vue&type=style&index=0&id=29db8afe&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29db8afe"]])

export default __exports__